import React from 'react'
import { ChartBlueBox } from '../../charts/chart.common'
import { ChartOthers } from '../../charts/chart.others'

export default function ProductWiseAnalysisCard() {
  return (
    <div className='ml-2' style={{ backgroundColor : "white" , padding : "1% 2%" , borderRadius : "5px" , width : "70%" , height : "auto" }}>
     <h4 className='is-size-5 wd_100' >Product-Wise Analysis</h4> 
       <div className="column is-12" >
                         {/* <ChartBlueBox headingText='Product-wise Analysis' > */}
                             <div style={{ marginLeft: '10px', marginRight: '10px' }}>
                                 <ChartOthers />
                             </div>
                         {/* </ChartBlueBox> */}
                     </div>
      
    </div>
  )
}